import { Fragment, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useShop } from 'hooks';
import { LoginForm } from 'components/home';
import group1 from 'assets/pictures/Group 1.png';

const Home = () => {
	const { isLoggedIn } = useShop();
	const navigate = useNavigate();

	useEffect(() => {
		if (isLoggedIn) {
			navigate('/products');
		}
	}, [isLoggedIn]);

	return (
		<Fragment>
			<div className="d-flex min-vh-100">
				{/* Left Side: Login */}
				<div className="d-flex flex-column justify-content-center align-items-center w-100 w-lg-50 bg-white px-4 px-lg-5">
					
					<div style={{ width: '100%', maxWidth: '300px' }}>
						<LoginForm />
					</div>
				</div>

				{/* Right Side: Light Pink Background with Image */}
				<div className="w-50 d-none d-lg-flex bg-light-pink w-100 px-4 px-lg-5 p-4">
					<img
						src={group1}
						alt="Login Visual"
						className="img-fluid w-100 h-100 object-fit-cover px-4 px-lg-5 p-4"
						style={{ objectFit: 'cover' }}
					/>
				</div>
			</div>
		</Fragment>
	);
};

export default Home;
